import $ from "jquery";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useRef,
} from "react";

window.jQuery = window.$ = $;
require("owl.carousel");

const OwlCarousel = forwardRef(({ className, children, options }, ref) => {
  const carouselRef = useRef(null);

  useImperativeHandle(ref, () => ({
    goTo(index) {
      $(carouselRef.current).trigger("to.owl.carousel", [index, 0]);
    },
    getCurrentIndex() {
      return $(carouselRef.current).find(".owl-item.active").first().index();
    },
  }));

  useEffect(() => {
    const $carousel = $(carouselRef.current);
    $carousel.owlCarousel({
      loop: true,
      rewind: false,
      margin: options.margin || 10,
      nav: options.nav || true,
      dots: options.dots || false,
      navText: options.navText || [
        '<i class="fas fa-angle-left"></i>',
        '<i class="fas fa-angle-right"></i>',
      ],
      responsive: options.responsive || {
        0: { items: 1 },
        576: { items: 2 },
        768: { items: 3 },
        992: { items: 4 },
        1200: { items: 5 },
      },
      ...options,
    });

    return () => {
      if ($carousel.length) {
        try {
          $carousel.trigger("destroy.owl.carousel");
        } catch (e) {
          console.warn("Error destroying carousel:", e);
        }
      }
    };
  }, [options]);

  return (
    <div ref={carouselRef} className={`owl-carousel ${className}`}>
      {children}
    </div>
  );
});

export default memo(OwlCarousel);
